import React from "react";

//images
import SiteBlindado from "../../../img/certifies/site-blindado.png";
import ReclameAqui from "../../../img/certifies/ra-1000.png";


export const ItemCardImageDefault = () => (
	<div className="item-card-info-default--icons">
		<a
			className="item-card-info-default--icon"
			href="https://www.siteblindado.com/consumidor/selo-blindado/?language=pt&hostname=www.maxmilhas.com.br"
			target="_blank"
		>
			<img width={80} src={SiteBlindado} />
		</a>
		<a
			className="item-card-info-default--icon"
			href="https://www.reclameaqui.com.br/empresa/maxmilhas/"
			target="_blank"
		>
			<img width={80} src={ReclameAqui} />
		</a>
	</div>
);

